/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

const StyledSearchInput = styled.input`
  border: none;
  outline: none;
  border-radius: 0.5rem;
  background: ${COLORS.GRAY_900};
  color: white;
  padding: 0.5rem;
  flex-grow: 1;
  ::placeholder {
    color: ${COLORS.GRAY_400};
  }
`;

export default StyledSearchInput;
